<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import {
    Col,
    FormGroup,
    Icon,
    Row
  } from "sveltestrap";
  import { thirdsService } from "../services";
  import type { Third } from "../Model/Third";
    import { Link } from "svelte-navigator";

  const dispatch = createEventDispatcher();

  let thirds: Third[];
  let offset = 0;
  let limit = 10;
  let searchFilter = null;


  async function seachThird(searchFilter) {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: JSON.stringify({
          searchFilter: searchFilter,
          searchLawyers: false
        }),
      },
    };

    thirds = await thirdsService.findThirds(opts);
  }

  async function changeThird(third) {
    dispatch("changeThird", third);
  }

</script>

      <Row>
        <Col xs="12">
          <form on:submit|preventDefault={seachThird}>
            <FormGroup>
              <div class="input-group">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Introduzca nombre o DNI"
                  on:input={() => {seachThird(searchFilter)}}
                  bind:value={searchFilter}
                />
                <button
                  class="btn btn-secondary"
                  type="submit"
                >
                  <Icon name="search" />

                </button>
              </div>
            </FormGroup>
          </form>
        </Col>
        {#if thirds?.length}
          <div class="col-12" style="height:400px; overflow:auto;">
            <table style=" width:100% ">
              <thead>
                <th scope="col">Nombre</th>
                <th scope="col">DNI</th>
                <th scope="col" />
              </thead>
              <tbody>
                
                  {#each thirds as third}
                    <tr>
                      <td>
                        <a href="/tercero/{third.id}" target="blank">
                          {third.name}
                          {third.surname1}
                          {#if third.surname2}{third.surname2}{/if}
                        </a>
                      </td>
                      <td>{third.document}</td>
                      <td class="text-end">
                        <button class="btn btn-success btn-sm" type="button" on:click={() => changeThird(third)}>
                            <Icon name="check" />
                        </button>
                      </td>
                    </tr>
                  {/each}

              </tbody>
            </table>
          </div>
        {:else}
          <div class="text-center">
            <h5>No terceros para mostrar</h5>
          </div>
        {/if}
      </Row>

<style>
</style>
